import { Orientation } from "expo-screen-orientation";

export function isLandscape(deviceOrientation: Orientation) {
    return [Orientation.LANDSCAPE_LEFT, Orientation.LANDSCAPE_RIGHT].includes(deviceOrientation)
}
